//POLYFILLS
import 'core-js/fn/array/find';
import 'core-js/fn/number/is-integer';

//VENDOR
import 'jquery';
import 'bootstrap/dist/js/bootstrap';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker';
//import 'inputmask';
//import 'video.js/dist/video.js';
//import 'videojs-contrib-media-sources/dist/videojs-contrib-media-sources.js';
//import 'videojs-contrib-hls.js/dist/videojs-contrib-hlsjs.min.js';

//SHARED - GENERIC
import './shared/templates/helpers/helpers';
import './shared/components/ng-webportal/webportal';

//SHARED - COMPONENTS
//import './shared/components/header/header';
import './shared/components/header2/header';
import './shared/components/header2/live-drawing/live-drawing';
import './shared/components/video-promo/video-promo';
import './shared/components/draw-promo/draw-promo';
import './shared/components/column-layout/column-layout';

//FEATURES
import './features/scratchers/scratcher-search';
import './features/scratchers/digital-scratcher';
import './features/related-games/related-games';
import './features/related-games/scratcher-related-games/scratcher-related-games';
import './features/related-games/printnplay-related-games/printnplay-related-games';
import './features/winning-numbers/winning-numbers';
import './features/winning-numbers/winning-numbers-top-drawer/winning-numbers-top-drawer';
import "./features/check-my-numbers/check-my-number-detail/check-my-number-detail";
import './features/check-my-numbers/check-my-numbers';
import './features/draw-games/draw-games';
import './features/draw-games/past-numbers/past-numbers';
import './features/random-number-generator/random-number-generator';
import './features/printnplay/printnplay-search/printnplay-search';
import './features/printnplay/printnplay-details/printnplay-details';
import './features/find-retailer/find-retailer';
import './features/latest-winners/latest-winners';
import './features/faqs/faqs';
import './features/contactus/contactus';
import './features/tellafriend/tellafriend';
import './features/extrachances/entertickets/entertickets';
import './features/extrachances/entertickets/extrachances-entertickets';
import './features/extrachances/enterticketscounter/enterticketscounter';
import './features/extrachances/extrachances/extrachances';
import './features/careers/careers';
import './features/alert-signup/alert-signup';


// WEBPACK FOOTER //
// ./app.js